import { Component } from 'preact';
import PropTypes from 'prop-types';

// Components
import Label from '../../Form/Label';
import Description from '../../Form/Description';
import { actionHandler } from '../../../utilities/form/formUtils';

class InputRadio extends Component {
  constructor(props) {
    super(props);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    const {
      variant,
    } = this.props;
    this.state = {
      isLink: variant === 'link',
    };
  }

  onChangeHandler(event) {
    const {
      actions,
      dispatch,
      onChange,
      id,
      groupName,
      updateRadio,
      values,
      setValues,
    } = this.props;
    // Fire Update Radio Function
    updateRadio(groupName, id);
    // If isLink then the action should be fired on the label, and not the checkbox
    const { isLink } = this.state;
    if (!isLink && actions && actions.length > 0) {
      actionHandler(actions, onChange, event, dispatch, values, setValues);
    } else {
      onChange(event);
    }
  }

  onKeyDownHandler = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      this.props.onChange({ target: { value: this.props.id } });
    }
  };

  render() {
    const {
      actions,
      desc,
      dispatch,
      groupName,
      id,
      label,
      onBlur,
      required,
      activeRadio,
      values,
      setValues,
    } = this.props;
    return (
      <div className="form__field form__field--radio">

        {/* Input Field */}
        <input
          className="form__item"
          type="radio"
          name={groupName}
          id={id}
          onChange={e => this.onChangeHandler(e)}
          onBlur={onBlur}
          value={id}
          required={required}
          checked={activeRadio === id}
          tabIndex={0}
          onKeyDown={this.onKeyDownHandler}
        />

        {/* Label */}
        {label &&
        <Label
          id={id}
          label={label}
          actions={actions}
          dispatch={dispatch}
          values={values}
          setValues={setValues}
        />
        }

        {/* Description */}
        {desc &&
        <Description desc={desc}/>
        }

      </div>
    );
  }
}

export default InputRadio;

InputRadio.defaultProps = {
  actions: null,
  label: null,
  desc: null,
  variant: null,
  required: false,
};

InputRadio.propTypes = {
  id: PropTypes.string.isRequired,
  groupName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  activeRadio: PropTypes.bool.isRequired,
  updateRadio: PropTypes.func.isRequired,
  actions: PropTypes.object,
  required: PropTypes.bool,
  label: PropTypes.string,
  variant: PropTypes.string,
  desc: PropTypes.string,
  values: PropTypes.array.isRequired,
  setValues: PropTypes.func.isRequired,
};
